import { Granularity } from 'types/contracts.ts'

export type PlanConsumptionContentProps = {
  compact?: boolean
  chartLayoutClassName?: string
}

export type AvailableMarketPriceGranularity = Extract<Granularity, Granularity.HOUR | Granularity.QUARTER_HOUR>

/** A consecutive timeframe of periods with the lowest prices, e.g. { from: '09:00', until: '10:30' } */
export type OffPeakRange = {
  from: string
  until: string
}

export enum ConsumptionView {
  TODAY = 'today',
  TOMORROW = 'tomorrow'
}
